import { render, staticRenderFns } from "./serial-table-list.vue?vue&type=template&id=abcf99ba"
import script from "./serial-table-list.vue?vue&type=script&lang=js"
export * from "./serial-table-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports